// https://lincolnprofilev9.cms.dealer.com/lincoln-hybrid-electric-vehicles.htm
export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({ eventData: { url } }) => {
					return (
						url === '/new-inventory/index.htm?normalFuelType=Hybrid'
					);
				},
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev:phev:content:search inventory',
							onclickLinkName: '{client}ev:phev:content:action'
						}
					}
				}
			},
			{
				logic: ({ eventData: { url } }) => {
					return url.includes('play.google.com');
				},
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev:phev:content:app download:google',
							onclickLinkName: '{client}ev:phev:content:action'
						}
					}
				},
				trigger: 'google-referral-exit'
			},
			{
				logic: ({ eventData: { url } }) => {
					return url.includes('apps.apple.com');
				},
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev:phev:content:app download:apple',
							onclickLinkName: '{client}ev:phev:content:action'
						}
					}
				},
				trigger: 'apple-referral-exit'
			}
		],
		widgetUserEvent: [
			{
				logic: ({ eventData: { action, widgetName } }) => {
					return (
						widgetName === 'ws-accordion-content' &&
						action === 'clicked'
					);
				},
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'ev:phev:content:interior',
							onclickLinkName: '{client}ev:phev:content:action'
						}
					}
				}
			}
		]
	},
	triggerEvents: {
		'google-referral-exit': {
			payload: {
				directCall: 'referral-exit',
				payload: {
					onclick: {
						onclick: 'referral:app download:google',
						referredTo: 'app download:google',
						onclickLinkName: 'referral:exit'
					},
					event: 'brand referral'
				}
			}
		},
		'apple-referral-exit': {
			payload: {
				directCall: 'referral-exit',
				payload: {
					onclick: {
						onclick: 'referral:app download:apple',
						referredTo: 'app download:apple',
						onclickLinkName: 'referral:exit'
					},
					event: 'brand referral'
				}
			}
		}
	}
};
